import { passwordStrength } from 'check-password-strength';

export enum PasswordStrength{
    TooWeak,
    Weak,
    Medium,
    Strong,
}
interface IPasswordStrengthResult{

    id: PasswordStrength,
    value: string,
    length: number

}
export const getPasswordStrength = (password: string): IPasswordStrengthResult => passwordStrength(password);
